import React, { useState } from 'react';
import { Box, Grid, Typography, Paper, Button, IconButton, TextField } from '@mui/material';
import { WSIcons } from '../../commonFunctions/iIcons';

export const BarcodeView: React.FC = () => {
    const [input, setInput] = useState("");

    const handleKeyPress = (key: string) => {
      setInput((prev) => prev + key);
    };
  
    const handleBackspace = () => {
      setInput((prev) => prev.slice(0, -1));
    };
  
    const handleEnter = () => {
      setInput((prev) => prev + "\n");
    };
  
    // Keys organized by rows
    const keysRow1 = ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"];
    const keysRow2 = ["a", "s", "d", "f", "g", "h", "j", "k", "l"];
    const keysRow3 = ["⇧", "z", "x", "c", "v", "b", "n", "m", "⌫"];
    const keysRow4 = ["?123", ",", "a-z", " ", ".", "⏎"];

  return (
    <Grid  xs={12} sx={{ p: 2, }}>
      {/* Barcode Input Area */}
      <Paper sx={{ width: '100%', height: 200, bgcolor: '#cfcfcf', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography variant="h6">Enter Barcode</Typography>
      </Paper>
      <TextField
        value={input}
        onChange={(e) => setInput(e.target.value)}
        variant="outlined"
        fullWidth
        multiline
        rows={1}
        placeholder=""
        sx={{
          width: "100%",
          maxWidth: 800,
          mb: 2,
          backgroundColor: "#ffffff",
          "& .MuiOutlinedInput-root": {
            borderRadius: 0,
          },
        }}
      />

     
      {/* Keyboard Container */}
      <Box
        sx={{
          maxWidth: 800,
          width: "100%",
          backgroundColor: "#ffffff",
          borderRadius: 1,
          border: "1px solid #d3d3d3",
          p: 1,
        }}
      >
        {/* First Row */}
        <Grid container spacing={0.5} justifyContent="center">
          {keysRow1.map((key) => (
            <Grid item xs={1.2} key={key}>
              <Button
                onClick={() => handleKeyPress(key)}
                variant="outlined"
                fullWidth
                sx={{
                  minWidth: 0,
                  padding: "10px 0",
                  color: "#333",
                  backgroundColor: "#fff",
                  borderColor: "#ccc",
                  fontSize: "1rem",
                }}
              >
                {key}
              </Button>
            </Grid>
          ))}
        </Grid>

        {/* Second Row */}
        <Grid container spacing={0.5} justifyContent="center" sx={{ mt: 1 }}>
          {keysRow2.map((key) => (
            <Grid item xs={1.2} key={key}>
              <Button
                onClick={() => handleKeyPress(key)}
                variant="outlined"
                fullWidth
                sx={{
                  minWidth: 0,
                  padding: "10px 0",
                  color: "#333",
                  backgroundColor: "#fff",
                  borderColor: "#ccc",
                  fontSize: "1rem",
                }}
              >
                {key}
              </Button>
            </Grid>
          ))}
        </Grid>

        {/* Third Row */}
        <Grid container spacing={0.5} justifyContent="center" sx={{ mt: 1 }}>
          {keysRow3.map((key) => (
            <Grid item xs={key === "⌫" ? 2.4 : 1.2} key={key}>
              {key === "⌫" ? (
                <IconButton
                  onClick={handleBackspace}
                  sx={{
                    width: "100%",
                    backgroundColor: "#fff",
                    borderColor: "#ccc",
                    borderRadius: 1,
                  }}
                >
                  <WSIcons.BackspaceIcon fontSize="small" />
                </IconButton>
              ) : (
                <Button
                  onClick={() => handleKeyPress(key)}
                  variant="outlined"
                  fullWidth
                  sx={{
                    minWidth: 0,
                    padding: "10px 0",
                    color: "#333",
                    backgroundColor: "#fff",
                    borderColor: "#ccc",
                    fontSize: "1rem",
                  }}
                >
                  {key}
                </Button>
              )}
            </Grid>
          ))}
        </Grid>

        {/* Fourth Row */}
        <Grid container spacing={0.5} justifyContent="center" sx={{ mt: 1 }}>
          {keysRow4.map((key) => (
            <Grid item xs={key === " " ? 4.8 : 1.2} key={key}>
              {key === "⏎" ? (
                <Button
                  onClick={handleEnter}
                  variant="outlined"
                  fullWidth
                  sx={{
                    minWidth: 0,
                    padding: "10px 0",
                    color: "#333",
                    backgroundColor: "#fff",
                    borderColor: "#ccc",
                    fontSize: "1rem",
                  }}
                >
                  {key}
                </Button>
              ) : (
                <Button
                  onClick={() => handleKeyPress(key)}
                  variant="outlined"
                  fullWidth
                  sx={{
                    minWidth: 0,
                    padding: "10px 0",
                    color: "#333",
                    backgroundColor: "#fff",
                    borderColor: "#ccc",
                    fontSize: "1rem",
                  }}
                >
                  {key === " " ? "Space" : key}
                </Button>
              )}
            </Grid>
          ))}
        </Grid>
      </Box>
    </Grid>
  );
};

